














































































































import { Box, Flex, AltInputLabel, BaseModal, Button } from '../../atoms'
import { SocialBox } from '../../molecules'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { mapActions } from 'vuex'
import { FACEBOOK_SOCIAL, LINE_SOCIAL, APPLE_SOCIAL } from '../../../constant/social'
import { REQUEST_SOCIAL_LOGIN, AUTH_MODULE } from '../../../store/modules/auth/constant'
import { UNLINK_PROVIDER, PROFILE_MODULE } from '../../../store/modules/profile/constant'
import { SocialLoginPayload } from '../../../store/api/type'

@Component({
  components: {
    Box,
    Flex,
    AltInputLabel,
    SocialBox,
    BaseModal,
    Button
  },
  methods: {
    ...mapActions(AUTH_MODULE, [REQUEST_SOCIAL_LOGIN]),
    ...mapActions(PROFILE_MODULE, [UNLINK_PROVIDER])
  }
})
export default class SocialMappingBox extends Vue {
  @Prop({ required: false, type: Array }) readonly providers!: any
  hasFacebook = false
  hasLine = false
  hasApple = false
  facebookDisplayName = 'ผูกบัญชีเฟสบุค'
  lineDisplayName = 'ผูกบัญชีไลน์'
  appleDisplayName = 'ผูกบัญชีแอปเปิล'
  facebookDefaultDisplayName = 'ผูกบัญชีเฟสบุค'
  lineDefaultDisplayName = 'ผูกบัญชีไลน์'
  appleDefaultDisplayName = 'ผูกบัญชีแอปเปิล'

  modalUnlinkVisible = false
  modalUnlinkFailedVisible = false
  modalUnlinkSuccessVisible = false
  modalHeaderUnlinkProvider = ''
  providerUnlinkStandby = ''
  unlinkError = ''
  unlinkHeaderIcon = 'check-circle'
  unlinkHeaderIconColor='success'

  @Watch('providers')
  bindProvidersData() {
    for (const e of this.providers) {
      switch (e.provider) {
        case APPLE_SOCIAL:
          this.hasApple = true
          this.appleDisplayName = e.displayName
          break
        case FACEBOOK_SOCIAL:
          this.hasFacebook = true
          this.facebookDisplayName = e.displayName
          break
        case LINE_SOCIAL:
          this.hasLine = true
          this.lineDisplayName = e.displayName
          break
      }
    }
  }

  capitalize (s: string) {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  unlinkSocialToggle(provider: string) {
    this.modalHeaderUnlinkProvider = 'ลบการผูกบัญชีกับ ' + this.capitalize(provider)
    this.providerUnlinkStandby = provider
    this.modalUnlinkVisible = !this.modalUnlinkVisible
  }

  async unlinkSocial() {
    if (!this.providerUnlinkStandby) {
      return
    }
    const resp = await (this as any)[UNLINK_PROVIDER](this.providerUnlinkStandby)
    if (resp.code === 200) {
      this.hideUnlink(this.providerUnlinkStandby)
      this.modalUnlinkSuccessVisible = !this.modalUnlinkSuccessVisible
    } else {
      this.unlinkError = resp?.error_message
      this.modalUnlinkFailedVisible = !this.modalUnlinkFailedVisible
    }
    this.modalUnlinkVisible = !this.modalUnlinkVisible
  }
  onCloseUnlinkModal() {
    this.modalHeaderUnlinkProvider = ''
    this.providerUnlinkStandby = ''
    this.modalUnlinkVisible = !this.modalUnlinkVisible
  }
  onCloseUnlinkFailedModal() {
    this.modalUnlinkFailedVisible = !this.modalUnlinkFailedVisible
  }
  onCloseUnlinkSuccessModal() {
    this.modalUnlinkSuccessVisible = !this.modalUnlinkSuccessVisible
  }
  hideUnlink(provider: string): void {
    switch (provider) {
      case FACEBOOK_SOCIAL:
        this.hasFacebook = !this.hasFacebook
        this.facebookDisplayName = this.facebookDefaultDisplayName
        break
      case LINE_SOCIAL:
        this.hasLine = !this.hasLine
        this.lineDisplayName = this.lineDefaultDisplayName
        break
      case APPLE_SOCIAL:
        this.hasApple = !this.hasApple
        this.appleDisplayName = this.appleDefaultDisplayName
        break
    }
  }
  mappingFacebook(): void {
    if (!this.hasFacebook) {
      this.mappingSocial(FACEBOOK_SOCIAL)
    }
  }
  mappingLine(): void {
    if (!this.hasLine) {
      this.mappingSocial(LINE_SOCIAL)
    }
  }
  mappingApple(): void {
    if (!this.hasApple) {
      this.mappingSocial(APPLE_SOCIAL)
    }
  }
  mappingSocial(provider: string) {
    const payload: SocialLoginPayload = {
      provider: provider,
      action: 'out of flow provider binding',
      redirect_url: location.href,
      email:'', 
      access_token:'', 
      challenge:''
    }
    ;(this as any)[REQUEST_SOCIAL_LOGIN](payload)
    return true
  }
}
